module.exports = __webpack_public_path__ + "img/prismic-logo.c4913e51.svg";